
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1405Dialog extends Serenity.EntityDialog<Report_1405Row, any> {
        protected getFormKey() { return Report_1405Form.formKey; }
        protected getIdProperty() { return Report_1405Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1405Row.localTextPrefix; }
        protected getNameProperty() { return Report_1405Row.nameProperty; }
        protected getService() { return Report_1405Service.baseUrl; }
        protected getDeletePermission() { return Report_1405Row.deletePermission; }
        protected getInsertPermission() { return Report_1405Row.insertPermission; }
        protected getUpdatePermission() { return Report_1405Row.updatePermission; }

        protected form = new Report_1405Form(this.idPrefix);

    }
}